// src/components/pages/CoursesPanel.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FiBookOpen,
  FiClock,
  FiCheckCircle,
  FiTrendingUp,
  FiSlash,
  FiUsers,
  FiUploadCloud,
  FiAlertCircle,
} from "react-icons/fi";

const CoursesPanel = () => {
  const navigate = useNavigate();

  // mock de cursos con slug para poder abrir el currículum
  const cursos = [
    {
      id: 1,
      slug: "trabajo-en-equipo", // tiene currículum
      nombre: "Trabajo en Equipo",
      resultado: "4%",
      vencimiento: "agosto 26, 2025 4:05 am",
      finalizacion: "-",
      thumb: "1",
      estado: "en-curso",
    },
    {
      id: 2,
      slug: "comunicacion-efectiva", // tiene currículum
      nombre: "Comunicación Efectiva",
      resultado: "0%",
      vencimiento: "agosto 25, 2025 2:20 pm",
      finalizacion: "-",
      thumb: "2",
      estado: "suspendido",
    },
    {
      id: 3,
      slug: "codigo-etica", // tiene currículum
      nombre: "Código de Ética y Conducta",
      resultado: "86.67%",
      vencimiento: "agosto 25, 2025 2:20 pm",
      finalizacion: "junio 17, 2025 2:04 am",
      thumb: "3",
      estado: "aprobado",
    },
    {
      id: 4,
      slug: "igualdad-genero", // tiene currículum
      nombre: "Igualdad de Género",
      resultado: "56%",
      vencimiento: "septiembre 2, 2025 9:10 am",
      finalizacion: "-",
      thumb: "1",
      estado: "en-curso",
    },
    {
      id: 5,
      // sin slug todavía => no abre currículum
      nombre: "Atención al Cliente",
      resultado: "100%",
      vencimiento: "septiembre 10, 2025 3:00 pm",
      finalizacion: "septiembre 10, 2025 3:15 pm",
      thumb: "2",
      estado: "finalizado",
    },
    {
      id: 6,
      nombre: "Normatividad Interna",
      resultado: "0%",
      vencimiento: "septiembre 15, 2025 11:30 am",
      finalizacion: "-",
      thumb: "3",
      estado: "suspendido",
    },
    {
      id: 7,
      nombre: "Onboarding de Personal",
      resultado: "—",
      vencimiento: "sin fecha",
      finalizacion: "-",
      thumb: "2",
      estado: "publicando",
      progreso: 42,
    },
    {
      id: 8,
      nombre: "Marketing Digital Básico",
      resultado: "—",
      vencimiento: "octubre 5, 2025 4:00 pm",
      finalizacion: "-",
      thumb: "1",
      estado: "pendiente",
    },
    {
      id: 9,
      nombre: "Seguridad Industrial",
      resultado: "—",
      vencimiento: "octubre 10, 2025 9:00 am",
      finalizacion: "-",
      thumb: "2",
      estado: "pendiente",
    },
  ];

  // tabs
  const [tab, setTab] = useState("todo");

  const filtrados =
    tab === "todo" ? cursos : cursos.filter((c) => c.estado === tab);

  // valores de alumnos como en tu screenshot azul
  const totalAlumnos = 20;
  const alumnosCompletado = 1;
  const alumnosEnProgreso = 19;

  const handleVerCurso = (curso) => {
    if (!curso.slug) return; // solo navegamos si el curso tiene currículum definido
    navigate(`/menu/lms/curso/${curso.slug}`);
  };

  return (
    <>
      <div className="profile-header-title">
        <h1>Perfil</h1>
      </div>

      {/* fila 1: cursos */}
      <div className="stats-grid stats-grid-wrap">
        <div className="stat-card">
          <div className="stat-icon professional mint">
            <FiBookOpen />
          </div>
          <div>
            <p className="stat-label">Total de cursos</p>
            <p className="stat-value">{cursos.length}</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon professional purple">
            <FiClock />
          </div>
          <div>
            <p className="stat-label">Cursos en progreso</p>
            <p className="stat-value">
              {cursos.filter((x) => x.estado === "en-curso").length}
            </p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon professional green">
            <FiCheckCircle />
          </div>
          <div>
            <p className="stat-label">Cursos aprobados</p>
            <p className="stat-value">
              {cursos.filter((x) => x.estado === "aprobado").length}
            </p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon professional pink">
            <FiTrendingUp />
          </div>
          <div>
            <p className="stat-label">Finalizados</p>
            <p className="stat-value">
              {cursos.filter((x) => x.estado === "finalizado").length}
            </p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon professional orange">
            <FiSlash />
          </div>
          <div>
            <p className="stat-label">Cursos suspendidos</p>
            <p className="stat-value">
              {cursos.filter((x) => x.estado === "suspendido").length}
            </p>
          </div>
        </div>
      </div>

      {/* fila 2: alumnos */}
      <div className="stats-grid stats-grid-wrap extra-top">
        <div className="stat-card">
          <div className="stat-icon professional blue">
            <FiUsers />
          </div>
          <div>
            <p className="stat-label">Total de alumnos</p>
            <p className="stat-value">{totalAlumnos}</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon professional green">
            <FiCheckCircle />
          </div>
          <div>
            <p className="stat-label">Estudiante completado</p>
            <p className="stat-value">{alumnosCompletado}</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon professional purple">
            <FiUsers />
          </div>
          <div>
            <p className="stat-label">Estudiante en progreso</p>
            <p className="stat-value">{alumnosEnProgreso}</p>
          </div>
        </div>
      </div>

      {/* tabs - ahora con Publicando y Pendiente */}
      <div className="filter-tabs">
        <button
          className={`filter-tab ${tab === "todo" ? "active" : ""}`}
          onClick={() => setTab("todo")}
        >
          Todo
        </button>
        <button
          className={`filter-tab ${tab === "en-curso" ? "active" : ""}`}
          onClick={() => setTab("en-curso")}
        >
          En curso
        </button>
        <button
          className={`filter-tab ${tab === "finalizado" ? "active" : ""}`}
          onClick={() => setTab("finalizado")}
        >
          Finalizado
        </button>
        <button
          className={`filter-tab ${tab === "aprobado" ? "active" : ""}`}
          onClick={() => setTab("aprobado")}
        >
          Aprobado
        </button>
        <button
          className={`filter-tab ${tab === "suspendido" ? "active" : ""}`}
          onClick={() => setTab("suspendido")}
        >
          Suspendido
        </button>
        <button
          className={`filter-tab ${tab === "publicando" ? "active" : ""}`}
          onClick={() => setTab("publicando")}
        >
          Publicando
        </button>
        <button
          className={`filter-tab ${tab === "pendiente" ? "active" : ""}`}
          onClick={() => setTab("pendiente")}
        >
          Pendiente
        </button>
      </div>

      {/* contenido */}
      {tab === "publicando" ? (
        <div className="courses-grid fixed-cards">
          {filtrados.map((curso) => (
            <article key={curso.id} className="course-card fixed-card">
              <div
                className={`course-thumb course-thumb-${curso.thumb || 1}`}
              />
              <div className="course-body">
                <h3 className="course-title">{curso.nombre}</h3>
                <p className="course-meta">
                  <span className="status-pill publishing">
                    <FiUploadCloud /> Publicando…
                  </span>
                </p>
                <div className="progress-track">
                  <div
                    className="progress-bar"
                    style={{ width: `${curso.progreso || 28}%` }}
                  ></div>
                </div>
                <p className="progress-label">
                  Progreso de publicación: {curso.progreso || 28}%
                </p>
                <button
                  className="btn-action"
                  style={{
                    width: '100%',
                    fontSize: '13px',
                    padding: '0.5rem 1rem',
                    cursor: 'pointer',
                    transition: '0.2s',
                    fontFamily: "'Outfit', sans-serif"
                  }}
                  onClick={() => handleVerCurso(curso)}
                >
                  Ver detalles
                </button>
              </div>
            </article>
          ))}
        </div>
      ) : (
        <div className="courses-grid fixed-cards">
          {filtrados.map((curso) => (
            <article key={curso.id} className="course-card fixed-card">
              <div
                className={`course-thumb course-thumb-${curso.thumb || 1}`}
              />
              <div className="course-body">
                <h3 className="course-title">{curso.nombre}</h3>
                <p className="course-meta">
                  <span>
                    {curso.resultado && curso.resultado !== "—"
                      ? `Resultado: ${curso.resultado}`
                      : "Sin resultados"}
                  </span>
                  <span>{curso.estado}</span>
                </p>
                {curso.estado === "pendiente" && (
                  <p className="pending-line">
                    <FiAlertCircle /> En espera de publicación
                  </p>
                )}
                <button
                  className="btn-action"
                  style={{
                    width: '100%',
                    fontSize: '13px',
                    padding: '0.5rem 1rem',
                    cursor: 'pointer',
                    transition: '0.2s',
                    fontFamily: "'Outfit', sans-serif"
                  }}
                  onClick={() => handleVerCurso(curso)}
                >
                  Ver curso
                </button>
              </div>
            </article>
          ))}
        </div>
      )}
    </>
  );
};

export default CoursesPanel;
